<!-- referenced / controlled by the cart button in navtop -->
<div #stickyFooterCartPreviewOffCanvas class="offcanvas offcanvas-end" id="stickyFooterCartPreviewOffCanvas">

  <div class="offcanvas-body overflow-hidden p-0 corners">
    <div class="offcanvas-header p-0 ps-2">
      <div class="flex-grow-1">
        <h4 class="mb-0" i18n="@@StickyFooterMobileCartPreviewTitle">Cart</h4>
      </div>
      <button type="button" data-bs-dismiss="offcanvas" aria-label="Close" class="btn p-2">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <app-cart-preview></app-cart-preview>
  </div>

</div>
